import "../styles.scss";

import { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { postMessageSendPush } from "../../../../store/middleware";

function ModalSendPush({ modalSend, setModalSend, form, setForm }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.userReducer);

  const [success, setSuccess] = useState(false);

  const closeModal = () => {
    setModalSend(false);
    setSuccess(false);
    setForm({});
  };

  const handleSend = () => {
    if (!form.group || (form.group === "specific-student" && !form.specificFilter)) return;

    const body = {
      userId: user?.id,
      group: form.group,
      messageId: form.messageId,
      specificFilter: form.specificFilter?.trim(),
    };

    dispatch(postMessageSendPush(body)).then((res) => res && setSuccess(true));
  };

  return (
    <Dialog
      open={modalSend}
      onClose={closeModal}
      classes={"modalPush"}
      className="modalPush"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="contentModal">
        <h3 className="title">{t("SEND").concat(" ").concat(t("PUSH"))}</h3>

        {!success ? (
          <form>
            <label className="labelModal">{t("GROUP")}</label>
            <select
              value={form.group}
              onChange={({ target }) => setForm((state) => ({ ...state, group: target.value }))}
            >
              <option value="">{t("SELECT")}</option>
              <option value="specific-student">specific-student</option>
              <option value="b2c-active">b2c-active</option>
              <option value="b2b-active">b2b-active</option>
              <option value="teacher">teacher</option>
            </select>

            {form.group === "specific-student" && (
              <>
                <label className="labelModal">{t("EMAIL")}</label>
                <input
                  type="email"
                  value={form.specificFilter}
                  onChange={({ target }) => setForm((state) => ({ ...state, specificFilter: target.value }))}
                />
              </>
            )}
          </form>
        ) : (
          <h4>Push sent successfully</h4>
        )}

        <div className="footer">
          <button className="buttonModalBack" onClick={closeModal}>
            {t("BACK")}
          </button>

          {!success ? (
            <button className="buttonModalSave" onClick={handleSend}>
              {t("SEND")}
            </button>
          ) : null}
        </div>
      </div>
    </Dialog>
  );
}

export default ModalSendPush;
